import React, { useState } from 'react';
import * as RouterDOM from 'react-router-dom';
import { ThemeProvider, CssBaseline, Box } from '@mui/material';
import v2Theme from './theme/v2Theme';
import { AuthModal } from './components/v2';
import {
  HomePage,
  Dashboard,
  ProfilePage,
  SendPage,
  PayPage,
  AboutPage,
} from './pages/v2';
import { useAuthState } from './utils/useAuthState';

const Router = RouterDOM.BrowserRouter as any;
const Route = RouterDOM.Route as any;
const Switch = RouterDOM.Switch as any;

// Functional component for React.FC + react-router-dom v5 compatibility
const AppV2: React.FC = () => {
  const [authModalOpen, setAuthModalOpen] = useState(false);
  const { user, loading } = useAuthState();

  // This branch is for embed.addrs.to - always in embed mode
  // No header, no footer, transparent background for iframe embedding

  return (
    <ThemeProvider theme={v2Theme}>
      <CssBaseline />
      {/* Global styles for embed mode */}
      <style>{`
        body {
          background: transparent !important;
          overflow-x: hidden;
        }
        html {
          background: transparent !important;
        }
        #root {
          background: transparent !important;
        }
        /* Ensure modals work properly in iframe */
        .MuiModal-root {
          position: fixed !important;
        }
      `}</style>
      <Router>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            minHeight: '100vh',
            background: 'transparent',
            // Remove scrollbars for cleaner embed appearance
            '::-webkit-scrollbar': {
              width: 0,
              background: 'transparent',
            },
            scrollbarWidth: 'none',
            msOverflowStyle: 'none',
            // Ensure proper layering for modals
            position: 'relative',
            isolation: 'isolate',
          }}
        >
          {/* No NavBar in embed mode - clean iframe embedding */}

          <Box
            component="main"
            sx={{
              flex: 1,
              padding: { xs: '0.5rem 0', sm: '1rem 0' },
              // Ensure content doesn't overflow in iframe
              maxWidth: '100%',
              overflow: 'hidden',
            }}
          >
            <Switch>
              <Route exact path="/" component={HomePage} />
              <Route exact path="/dashboard" component={Dashboard} />
              <Route exact path="/pay" component={PayPage} />
              <Route exact path="/about" component={AboutPage} />
              <Route exact path="/pay/:coin/:address" component={SendPage} />
              <Route exact path="/:handle/:coin" component={SendPage} />
              <Route exact path="/:handle" component={ProfilePage} />
            </Switch>
          </Box>

          {/* No Footer in embed mode - clean iframe embedding */}

          {/* Modals render in portal, will appear above iframe content */}
          <AuthModal
            open={authModalOpen}
            onClose={() => setAuthModalOpen(false)}
            onSuccess={() => {
              // Auth state will automatically update via useAuthState hook
              setAuthModalOpen(false);
            }}
          />
        </Box>
      </Router>
    </ThemeProvider>
  );
};

export default AppV2;
